export default {
  'paymentFraudControlSummaryGrid.actions': 'Actions',
  'paymentFraudControlSummaryGrid.accountNumber': 'Account Number',
  'paymentFraudControlSummaryGrid.accountName': 'Account Name',
  'paymentFraudControlSummaryGrid.paidAmount': 'PaidAmount',
  'paymentFraudControlSummaryGrid.exceptionItemCount': 'Items',
  'paymentFraudControlSummaryGrid.payItemCount': 'Pay',
  'paymentFraudControlSummaryGrid.returnItemCount': 'Return',
  'paymentFraudControlSummaryGrid.cutoff': 'Cutoff Time',
  'paymentFraudControlSummaryGrid.notAvailable': 'Not Available',
  'paymentFraudControlGrid.null': '--'
};
